const data = {
  age: {
    label: 'Current age',
    value: 0,
  },
  countries: {
    label: 'Countries visited',
    value: 10,
    link: 'https://www.google.com/maps/d/embed?mid=1iBBTscqateQ93pWFVfHCUZXoDu8&z=2',
  },
  location: {
    label: 'Current city',
    value: 'Vienna, Austria',
  },
  origin: {
    label: 'Born in',
    value: 'Buenos Aires, Argentina',
  },
};

export default data;
